

const html = `
<div>
<link rel="stylesheet" type="text/css" href="${process.env.hostDomain}/css/style-append-er.css" />
<div class="widgeter">
<a href="#" data-toggle-class="widgeter-modal-open" class="modal-toggler">
  <img class="widgeter-img" src="${process.env.hostDomain}/img/widget/er-logo.svg" alt="Esperto Risponde">
</a>
<div class="widgeter-content">
  <p class="widgeter-title">
    <a href="#" data-toggle-class="widgeter-modal-open" class="modal-toggler" type="button" aria-haspopup="dialog">
      L’Esperto Risponde ora è più veloce
    </a>
  </p>
  <p class="widgeter-txt">
    Poni un quesito gratuito o acquista la garanzia di risposta entro 48 ore lavorative
  </p>
</div>
<a class="widgeter-btn modal-loader" href="#" data-toggle-class="widgeter-modal-open">
  Invia quesito
</a>
</div>

</div>
`
/* todo: 
- possibilità di passare una config con il target id (strippare eventuale cancelletto se presente)
- path assoluti immagini e css dentro string html (adesso sono relativi)
*/

const defaultConf = {
  target: "widgetER",
  widget: html,

}

function createNodeFromString(string) {
  const el = document.createElement("div");
  el.innerHTML = string;
  return el.firstElementChild;
}


function appendStringIntoTargetById(string, target) {
  return document.getElementById(target).appendChild(createNodeFromString(string));
}

function appendStringIntoTargetByNode(string, node) {
  return node.appendChild(createNodeFromString(string));
}

function removeElementsByID(ids) {
  ids.forEach(id => {
    const el = document.getElementById(id);
    if (el) {
      el.parentNode.removeChild(el);
    }
  })
}

function removeWidget() {
  removeElementsByID(["widgeter-modal-form", "widgeter-modal-feedback", 'widgeter-modal-questiontypes'])
  document.querySelectorAll('.widgeter-container').forEach((el, i) => {
    const parent = el.parentNode;
    parent.removeChild(el)
  })
}

function goBack(e) {
  e.preventDefault();

  // Rilascio la focus trap sulla sezione #widgeter-modal-form
  ModalTrapManager.cleanupSecondary();

  removeElementsByID(["widgeter-modal-form"]);

  // Riattivo la focus trap per la modale principale
  const mainModalElement = document.querySelector(".widgeter-container");
  if (mainModalElement) {
    ModalTrapManager.initialize(mainModalElement);
  }
}

function topicChange(e) {

  if (e.target.closest("#widgeter-modal-topics")) {
    const value = document.getElementById("widgeter-modal-topics").value
    fetch((`${process.env.hostDomain}/api/formWidgetER?id=${value}`),{
      credentials: 'include',
    })
      .then(response => response.text())
      .then(data => {
        // questo è l'html della select che ci arriva, butto quella vecchia, metto quello nuovo.
        parent = document.getElementById("widgeter-modal-subtopics").parentNode;
        removeElementsByID(["widgeter-modal-subtopics"]);
        appendStringIntoTargetByNode(data, parent);
      })
  }
}

function createModalTrap(modalElement) {
  console.log('createModalTrap chiamato per elemento:', modalElement);

  if (!modalElement) {
    console.error('Nessun elemento modale fornito a createModalTrap');
    return null;
  }

  let previousActiveElement = document.activeElement;
  let currentFocusableElements = [];
  let isActive = false;

  function updateFocusableElements() {
    currentFocusableElements = Array.from(modalElement.querySelectorAll(
      'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
    )).filter(el => {
      let style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });
  }

  function setInitialFocus() {
    // console.log('setInitialFocus chiamato');
    updateFocusableElements();
    console.log('Elementi focusabili trovati:', currentFocusableElements.length);

    if (currentFocusableElements.length > 0) {
      requestAnimationFrame(() => {
        // console.log('Imposto focus su:', currentFocusableElements[0]);
        console.log('Imposto focus sul primo elemento trovato');
        currentFocusableElements[0].focus();
      });
    }
  }

  function handleKeydown(event) {
    if (!isActive) return;

    const isTabPressed = event.key === 'Tab' || event.keyCode === 9;
    const isEscapePressed = event.key === 'Escape' || event.keyCode === 27;

    // Aggiorno gli elementi focusabili ad ogni pressione del tab
    if (isTabPressed) {
      updateFocusableElements();
    }

    // Gestione tasto ESC
    if (isEscapePressed) {
      event.preventDefault();
      closeModal();
      removeWidget();
      return;
    }

    if (!isTabPressed || currentFocusableElements.length === 0) return;

    const firstFocusableElement = currentFocusableElements[0];
    const lastFocusableElement = currentFocusableElements[currentFocusableElements.length - 1];

    // Gestione focus trap
    if (event.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        event.preventDefault();
        lastFocusableElement.focus();
      }
    } else {
      if (document.activeElement === lastFocusableElement) {
        event.preventDefault();
        firstFocusableElement.focus();
      }
    }
  }

  function closeModal() {
    isActive = false;
    modalElement.removeAttribute('tabindex');
    document.body.classList.remove('widgeter-modal-open');
    if (previousActiveElement) {
      previousActiveElement.focus();
    }
    cleanup();
  }

  function cleanup() {
    document.removeEventListener('keydown', handleKeydown);
    modalElement.removeEventListener('close', cleanup);
  }

  function initialize() {
    console.log('Inizializzazione trap');
    isActive = true;
    modalElement.setAttribute('role', 'dialog');
    modalElement.setAttribute('aria-modal', 'true');

    // Rimuovo aria-modal da tutte le altre modali attive
    document.querySelectorAll('.widgeter-modal[aria-modal="true"]').forEach((otherModal) => {
      if (otherModal !== modalElement) {
        otherModal.removeAttribute('aria-modal');
      }
    });

    document.addEventListener('keydown', handleKeydown);
    modalElement.addEventListener('close', cleanup);

    // Imposto il focus iniziale
    requestAnimationFrame(() => {
      console.log('Imposto focus iniziale dopo inizializzazione della modale o di un suo nuovo template');
      setInitialFocus();
    });
  }

  initialize();

  return {
    release: cleanup,
    reinitialize: initialize,
    updateFocus: setInitialFocus,
    close: closeModal
  };
}

// Gestore globale della modal trap
const ModalTrapManager = {
  currentTrap: null,
  secondaryTrap: null,
  feedbackTrap: null,

  // Fa riferimento all'elemento con classe .widgeter-modal
  initialize(modalElement) {
    // console.log('ModalTrapManager.initialize chiamato', modalElement);
    if (this.currentTrap) {
      console.log('Rilascio trap esistente prima di inizializzarne una nuova');
      this.currentTrap.release();
    }
    this.currentTrap = createModalTrap(modalElement);
  },

  // Fa riferimento all'elemento con classe .widgeter-modal-form
  initializeSecondary(modalElement) {
    if (this.secondaryTrap) {
      this.secondaryTrap.release();
    }
    this.secondaryTrap = createModalTrap(modalElement);
  },

  // Fa rifereimento all'elemento con id widgeter-modal-feedback
  initializeFeedback(modalElement) {
    if (this.feedbackTrap) {
      this.feedbackTrap.release();
    }
    this.feedbackTrap = createModalTrap(modalElement);
  },

  cleanup() {
    console.log('ModalTrapManager.cleanup chiamato');
    // console.log('Trap corrente:', this.currentTrap);
    if (this.currentTrap && typeof this.currentTrap.release === 'function') {
      this.currentTrap.release();
    }
    this.currentTrap = null;
  },

  cleanupSecondary() {
    if (this.secondaryTrap && typeof this.secondaryTrap.release === 'function') {
      this.secondaryTrap.release();
    }
    this.secondaryTrap = null;
  },

  cleanupFeedback() {
    if (this.feedbackTrap && typeof this.feedbackTrap.release === 'function') {
      this.feedbackTrap.release();
    }
    this.feedbackTrap = null;
  }
};

function enhancedModalToggler(el) {
  el.addEventListener("click", function (e) {
    e.preventDefault();
    console.log('Modal toggler clicked');

    let modalElement = document.querySelector(".widgeter-container");
    console.log('Modal element trovato?', !!modalElement);

    document.body.classList.toggle("widgeter-modal-open");
    removeWidget();
    if (document.body.classList.contains("widgeter-modal-open")) {
      console.log('Chiusura modale');
      ModalTrapManager.cleanup();
    } else {
      console.log('Apertura modale');
      if (modalElement) {
        requestAnimationFrame(() => {
          console.log('Inizializzo trap per riapertura');
          ModalTrapManager.initialize(modalElement);
        });
      }
    }
  });
};

async function submitQuestion(e) {
  e.preventDefault();
  const title = document.getElementsByClassName("widgeter-question-title")[0].value;
  const topicId = document.getElementById("widgeter-modal-topics").value;
  const subTopicId = document.getElementById("widgeter-modal-subtopics").value;
  const text = document.getElementsByClassName("widgeter-modal-textarea")[0].getElementsByTagName("textarea")[0].value;
  const channelId = '0fa07a3f-2e29-5065-6fa2-31e959acdd98'; //to-do si possono mandare solo quesiti normali o anche di uno speciale?
  const typology = 'FREE';
  /*
   console.log("title", document.getElementsByClassName("widgeter-question-title")[0].value);
   console.log("topicId", document.getElementById("widgeter-modal-topics").value);
   console.log("subTopicId", document.getElementById("widgeter-modal-subtopics").value);
   console.log("text",  document.getElementsByClassName("widgeter-modal-textarea")[0].getElementsByTagName("textarea")[0].value); */

   
  if (!title || topicId === 'Selezione argomento' || subTopicId === 'Selezione sottoargomento' || !text || text === '') {
    if (!title) {
      document.querySelector('.widgeter-question-title').style.border = '1px solid red'
    }
    if (topicId === 'Selezione argomento') {
      document.querySelector('#widgeter-modal-topics').parentElement.style.border = '1px solid red'
    }
    if (subTopicId === 'Selezione sottoargomento') {
      document.querySelector('#widgeter-modal-subtopics').parentElement.style.border = '1px solid red'
    }
    if (!text || text === '') {
      document.querySelector('.widgeter-modal-textarea textarea').parentElement.style.border = '1px solid red'
    }
  } else {

    let questionId = '';
    questionId = await fetch(process.env.apiHost, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        accept: '*/*',
      },
      body: JSON.stringify({
        query: 'mutation mutationSendQuestionER($title: String, $topicId: String, $subTopicId: String, $text: String, $channelId: String, $typology: TypologyEnum){sendQuestion(input: {title: $title, topicId:$topicId, subTopicId: $subTopicId, text: $text, channelId: $channelId, typology: $typology })}',
        variables: { title, topicId, subTopicId, text, channelId, typology}
      }),
      credentials: 'include',
    })
      .then((response) => response.json())
      .then((result) =>  result.data.sendQuestion)
      .catch((error) => console.log('error fetch mutationSendQuestionER widgetER', error));


    fetch(`${process.env.hostDomain}/api/questionER?questionId=${questionId}`, {
      credentials: 'include',
    })
      .then(response => response.text())
      .then(result => {

        const target = document.getElementById("widgeter-modal-form").parentNode;
        removeElementsByID(["widgeter-modal-feedback","widgeter-modal-form", "widgeter-modal-questiontypes"])
        appendStringIntoTargetByNode(result, target);

        // Inizializza la focus trap per il feedback
        const feedbackElement = document.getElementById("widgeter-modal-feedback");
        if (feedbackElement) {
          ModalTrapManager.initializeFeedback(feedbackElement);
        }

        document.querySelectorAll(".modal-toggler")
          .forEach(enhancedModalToggler);
      })
  }
}

function textChange() {
  const textarea = document.querySelector('.widgeter-modal-textarea textarea');
  const charCount = document.getElementById("widgeter-modal-question-char-count");
  const textLength = textarea.value.length;
  charCount.textContent = textLength;
  if (textLength >= 1200) {
    textarea.value = textarea.value.substring(0, 1200);
    textarea.setAttribute('maxlength', '1200');
    charCount.textContent = 1200;
  } else {
    textarea.removeAttribute('maxlength');
  }
}

function modalER(target) {
  document.querySelector('.free-question').addEventListener('click', async function (e) {
    e.preventDefault();
    console.log('grazie per il tuo click');

    let email = '';
    email = await fetch(process.env.apiHost, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        accept: '*/*',
      },
      body: JSON.stringify({
        query: '{\n  profile {\n    userEmail\n  }\n}\n',
      }),
      credentials: 'include',
    })
      .then((response) => response.json())
      .then((result) => result.data.profile?.userEmail)
      .catch((error) => console.log('error fetch query profile widgetER', error));

    fetch(`${process.env.hostDomain}/api/formWidgetER?email=${email}`, {
      credentials: 'include',
    })
      .then((response) => response.text())
      .then((data) => {
        // Cleanup prima di cambiare contenuto
        ModalTrapManager.cleanup();

        // se ho cliccato free-question e l'avevo già fatto prima, butto prima via il contenuto del form e poi lo rimetto.
        removeElementsByID(['widgeter-modal-form']);
        appendStringIntoTargetById(data, target);

        // Inizializzo la focus trap su #widgeter-modal-form
        const modalFormElement = document.getElementById("widgeter-modal-form");
        if (modalFormElement) {
          ModalTrapManager.initializeSecondary(modalFormElement);
        };

        // eventi
        document.querySelectorAll('#widgeter-modal-form .modal-toggler').forEach(enhancedModalToggler);
        document.querySelector('#widgeter-modal-form .widgeter-modal-head-back').addEventListener('click', goBack);
        document.querySelector('#widgeter-modal-topics').addEventListener('change', topicChange);
        document.querySelector('#widgeter-modal-form .widgeter-btn--submit').addEventListener('click', submitQuestion);
        document.querySelector('#widgeter-modal-form input').addEventListener('focus', function (e) {
          e.target.style.border = '1px solid rgba(15, 15, 15, 0.25)'
        });
        const textarea = document.querySelector('.widgeter-modal-textarea textarea');
        textarea.addEventListener('input', textChange);
        textarea.addEventListener('paste', textChange);    
      });
  });
  document.querySelectorAll('.modal-toggler').forEach(enhancedModalToggler);
}

function openLogin() {
  // click chiudi
  document.querySelector(".modal-close")
    .addEventListener("click", function (e) {
      e.preventDefault();
      console.log('Chiudo modale login');
      document.body.classList.remove("modal-open");
    })
  // manca css -> bunker 
  // social login
}

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

function getReturnUrl(asPath) {
  return asPath && asPath.indexOf('?ErrMsg') > -1 ? asPath.split('?ErrMsg').shift() : asPath.split('&ErrMsg').shift();
}

function ModalLoader(isLogged, target) {
  console.log("fetch fetch")
  fetch(`${process.env.hostDomain}/api/widgetER?isLogged=${isLogged}`, {
    credentials: 'include',
  })
    .then(response => response.text())
    .then((data) => {
      // OK sostituire ##RURL## con return url (va calcolata lato client) response.replace(/##RURL##/gi)
      const rurl = getReturnUrl(document.location.href)
      data = data.replace(/##RURL##/gi, rurl);

      // Rimuovo eventuale trap esistente
      ModalTrapManager.cleanup();

      // le api mi mandano direttamente l'html da inserire. se c'è l'html del widget inserisco gli eventi per quello, altrimenti apri e chiudi login
      appendStringIntoTargetById(data, target)
      
      if (isLogged) {
        modalER(target)
        document.body.classList.toggle("widgeter-modal-open");
        // Inizializzo la modal trap dopo che il contenuto è stato caricato
        requestAnimationFrame(() => {
          const modalElement = document.querySelector('.widgeter-modal');
          // console.log('ModalLoader: Trovato elemento modale?', !!modalElement);
          if (modalElement) {
            ModalTrapManager.initialize(modalElement);
          }
        });
      } else {
        if (typeof window.extOpenLogin === "function") {
          extOpenLogin();
        } else {
          openLogin()
        }
      }
      
    })
}

function widgetER() {
  console.log("ready steady go")
  const config = Object.assign(defaultConf)
  const { target, widget } = config;
  // inserisco widget in pagina
  appendStringIntoTargetById(widget, target)
  
  // chiamo graph per sapere se l'utente è loggato
  let isLogged = document.cookie.indexOf("SoleAuth") > -1; // tentative, per non portarmi dietro tutta le cose in nilecookiemanager
  document.querySelector(".modal-loader").addEventListener("click", function (e) { e.preventDefault(); ModalLoader(isLogged, target) })
// manca: post sul form

}


window.widgetER = widgetER; // per widget caricati in lazy load

document.addEventListener('DOMContentLoaded', function () {
  console.log("****** dom content load")
  if (document.getElementById("widgetER").childNodes.length === 0) { // lo lancio solo se non ce ne sono altri in pagina
    widgetER()
  }

});